import { render, staticRenderFns } from "./EmployeeSettings.vue?vue&type=template&id=2962d31a&scoped=true&"
import script from "./EmployeeSettings.vue?vue&type=script&lang=js&"
export * from "./EmployeeSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSettings.vue?vue&type=style&index=0&id=2962d31a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2962d31a",
  null
  
)

export default component.exports